import BoardMembers from "../../../../src/components/board-members/BoardMembers";
import * as React from 'react';
export default {
  BoardMembers,
  React
};